import { render, staticRenderFns } from "./TravelHistory.vue?vue&type=template&id=598ee934&scoped=true"
import script from "./TravelHistory.vue?vue&type=script&lang=js"
export * from "./TravelHistory.vue?vue&type=script&lang=js"
import style0 from "./TravelHistory.vue?vue&type=style&index=0&id=598ee934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598ee934",
  null
  
)

export default component.exports